import { render, staticRenderFns } from "./v-chat-typing-indicator.vue?vue&type=template&id=6552d70a&scoped=true&"
import script from "./v-chat-typing-indicator.vue?vue&type=script&lang=js&"
export * from "./v-chat-typing-indicator.vue?vue&type=script&lang=js&"
import style0 from "./v-chat-typing-indicator.vue?vue&type=style&index=0&id=6552d70a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6552d70a",
  null
  
)

export default component.exports